export default __webpack_public_path__ + "static/media/background_aae_hud_factory_section_huds.91f53d1b.jpg";